// CommitChart.js
import { Line } from 'vue-chartjs'

export default {
  props: ['data'],
  extends: Line,
  name: 'LineChart',
  mounted () {
    this.setChart();
  },
  methods: {
    setChart() {
      let labels = this.data.date;
      let datasets = this.data.dataset;

      this.setMax(datasets);

      this.renderChart({
          labels: labels, // labels: ['11월 6일', '11월 7일']
          datasets: datasets  // datasets: [{backgroundColor: '#ff000', data:[0, 0], label: '회원수'}
        }, this.options
      )
    },
    // max, stepSize 세팅
    setMax(datasets) {
      let max = 0;
      datasets.forEach(item => {
        item.data.forEach(number => {
          if(number > max) max = number;
        })
      })
      for(let v of [10, 50, 100, 500, 1000, 5000, 10000, 50000, 100000, 500000]) {
        if(max < v) {
          this.options.scales.yAxes[0].ticks.max = v;
          this.options.scales.yAxes[0].ticks.stepSize = v/10;
          break;
        }
      }
    }
  },
  data() {
    return {
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 10,
              stepSize: 1
            }
          }]
        },
        legend:{
          display:false
        },
      }
    }
  }
}
